import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for login payload
 */
export interface LoginPayload {
  email: string;
  password: string;
}

/**
 * Interface for login response
 */
export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  user: {
    id: number;
    email: string;
    phone_number: string | null;
    first_name: string | null;
    last_name: string | null;
    date_joined: string;
    country_code: string;
    date_of_birth: string | null;
    display_photo: string | null;
    address: string | null;
    user_type: string;
    objective: string;
    referral: string | null;
    company_info: any | null;
  };
}

/**
 * Hook for logging in using TanStack React Query
 */
export const useLogin = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: LoginPayload) => {
      const response = await apiClient.post<LoginResponse>('/auth/login/', payload);
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Success',
        text: 'Login successful!',
        type: 'info',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to login';
      openToast({
        show: true,
        heading: 'Login Failed',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};